import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { _datiDetail } from '../../components/detail/detail.component';

@Component({
  selector: 'app-ana-trasportatori',
  templateUrl: './ana-trasportatori.component.html',
  styleUrls: ['./ana-trasportatori.component.css']
})
export class AnaTrasportatoriComponent implements OnInit {
  id;
  passaDettagli: _datiDetail[]=[
    {chiave:"id_anagrafica", titolo:'Unità Locali', api:'unitalocali'},
    {chiave:"id_anagrafica", titolo:'Automezzi', api:'automezzi'},
  ];
  constructor(private router:Router, private route: ActivatedRoute) { }

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id')
  }

  onSelectionChanged(event){
    
    console.log(event); // Record elezionato
   // alert(event.id);
}

logga(event){

}

}
